import { render, staticRenderFns } from "./ArtistProfile.vue?vue&type=template&id=e18ea920&scoped=true"
import script from "./ArtistProfile.vue?vue&type=script&lang=js"
export * from "./ArtistProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18ea920",
  null
  
)

export default component.exports